// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const spinda: PokeData = {
  "id": 327,
  "name": "spinda",
  "height": 11,
  "weight": 50,
  "base_experience": 126,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "tackle",
    "body-slam",
    "thrash",
    "double-edge",
    "psybeam",
    "hypnosis",
    "dizzy-punch",
    "flail",
    "feint-attack",
    "psych-up",
    "uproar",
    "teeter-dance",
    "copycat",
    "sucker-punch"
  ],
  "moves": [
    "tackle",
    "body-slam",
    "refresh",
    "headbutt",
    "growl",
    "quick-attack",
    "scratch",
    "leer",
    "supersonic",
    "purification",
    "splash",
    "tri-attack",
    "scary-face"
  ],
  "evolution_chain": {
    "id": 165,
    "item": null,
    "species": [
      {
        "name": "spinda",
        "order": 355,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 120,
    "speed": 120,
    "ability_power": 120
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
